module.exports = __webpack_public_path__ + "img/1.a90a65a3.jpg";